var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M24.6673 11.9267V13C24.6659 15.5158 23.8512 17.9638 22.3449 19.9788C20.8385 21.9938 18.7211 23.4679 16.3086 24.1812C13.896 24.8945 11.3175 24.8089 8.95753 23.937C6.59761 23.0652 4.58275 21.4538 3.21344 19.3433C1.84413 17.2327 1.19374 14.7361 1.35927 12.2257C1.52481 9.71533 2.49739 7.32572 4.13198 5.41326C5.76656 3.50079 7.97557 2.16795 10.4295 1.61351C12.8835 1.05907 15.451 1.31273 17.749 2.33667M24.6673 3.66667L13.0007 15.345L9.50066 11.845",
    stroke: "#039855",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fdee6fd6cb453060e35e7a033a36d38f.svg";
export { ForwardRef as ReactComponent };